module.exports = __webpack_public_path__ + "static/media/subscription-section-2.b3ce5ba7.png";